module.exports = __webpack_public_path__ + "static/media/all3d-new-logo-red.17c51aaa.svg";